import { MRT_ColumnDef, createMRTColumnHelper } from "material-react-table";
import { GridText } from "src/components/Grid/GridText";
import { useTranslation } from "react-i18next";
import { MrtColumns } from "src/components/Grid/hooks/columnsExtension/useGridColumns";
import { Icv } from "src/api/client-api/icv/useAllIcvs";

type Options = {
    icvs?: Icv[];
};

export const useIcvColumns = (options: Options): MrtColumns<Icv> => {
    const { t } = useTranslation();
    const { icvs } = options;

    const columnHelper = createMRTColumnHelper<Icv>();

    const mrt_columns = [
        columnHelper.accessor((row) => row.id, {
            id: "id",
            header: t("icvs.id", "ID"),
            Cell: (value) => {
                return <GridText value={value.renderedCellValue} />;
            },
        }),
        columnHelper.accessor("name", {
            header: t("icvs.name", "Name"),
            Cell: (value) => {
                return <GridText value={value.renderedCellValue} />;
            },
        }),
        columnHelper.accessor("code", {
            header: t("icvs.code", "Code"),
            Cell: (value) => {
                return <GridText value={value.renderedCellValue} />;
            },
        }),
        columnHelper.accessor("description", {
            header: t("icvs.description", "Description"),
            Cell: (value) => {
                return <GridText value={value.renderedCellValue || "-"} />;
            },
        }),
        columnHelper.accessor("groupName", {
            header: t("icvs.groupName", "Group Name"),
            Cell: (value) => {
                return <GridText value={value.renderedCellValue || "-"} />;
            },
        }),
        columnHelper.accessor("unitCode", {
            header: t("icvs.unit_code", "Unit code"),
            Cell: (value) => {
                return <GridText value={value.renderedCellValue} />;
            },
        }),
    ] as MRT_ColumnDef<Icv, string>[];

    return mrt_columns;
};
